import React from 'react'

import { functions } from '@wap-client/core'

import { Column, Row } from '@/components/base/gridview'
import Anchor from '@/components/base/anchor/Anchor'
import Image from '@/components/base/image'

import { FacilityListSearchProps } from './types'

const geturl = (domain: string) => {
  if (!domain.startsWith('http') && !domain.startsWith('https')) {
    return `https://${domain}`
  } else {
    return domain
  }
}

const SearchFacilityList: React.FunctionComponent<FacilityListSearchProps> = (
  props,
) => {
  const {
    column = {
      sizes: {
        xs: 12,
        sm: 6,
        md: 4,
        lg: 3,
      },
    },
    data = [],
    isRotated = false,
  } = props

  if (data.length) {
    return (
      <div
        className={`facility-list-search facility-list-search-${
          props.titlePosition || 'inner'
        } margin-top-2 margin-bottom-2`}
      >
        <Row>
          {data.map((item, index) => (
            <Column key={index} {...column}>
              <div className="facility-list-search-item">
                {item.anchor ? (
                  <Anchor href={geturl(item.anchor)}>
                    {!item.image ? (
                      <img
                        referrerPolicy="no-referrer"
                        src="/images/hotel-broken-400-500.png"
                        alt={item.title ?? 'Broken image'}
                      />
                    ) : (
                      <Image src={item.image} alt={item.title} />
                    )}
                    <div className="facility-list-search-item-content">
                      <h4>{item.title}</h4>
                    </div>
                  </Anchor>
                ) : (
                  <>
                    {!item.image ? (
                      <img
                        referrerPolicy="no-referrer"
                        src="/images/hotel-broken-400-500.png"
                        alt={item.title ?? 'Broken image'}
                      />
                    ) : (
                      <Image src={item.image} alt={item.title} />
                    )}
                    <div className="facility-list-search-item-content">
                      <h4>{item.title}</h4>
                    </div>
                  </>
                )}
              </div>
            </Column>
          ))}
        </Row>
      </div>
    )
  }

  return null
}

export default SearchFacilityList
